import _classCallCheck from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Pass } from "./Pass.js";
/**
 * A pass that disables the stencil test.
 */

export var ClearMaskPass =
/*#__PURE__*/
function (_Pass) {
  _inherits(ClearMaskPass, _Pass);

  /**
   * Constructs a new clear mask pass.
   */
  function ClearMaskPass() {
    var _this;

    _classCallCheck(this, ClearMaskPass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ClearMaskPass).call(this, "ClearMaskPass", null, null));
    _this.needsSwap = false;
    return _this;
  }
  /**
   * Disables the global stencil test.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [delta] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */


  _createClass(ClearMaskPass, [{
    key: "render",
    value: function render(renderer, inputBuffer, outputBuffer, delta, stencilTest) {
      renderer.state.buffers.stencil.setTest(false);
    }
  }]);

  return ClearMaskPass;
}(Pass);